import React, {useEffect, useRef, useState} from "react";
import {useNavigate}                        from "react-router-dom";
import {InputText}                          from "primereact/inputtext";
import {Toast}                              from "primereact/toast";
import {confirmDialog}                      from "primereact/confirmdialog";
import {Button}                             from "primereact/button";
import {DataTable}                          from "primereact/datatable";
import {Column}                             from "primereact/column";
import {FilterMatchMode}                    from "primereact/api";

import {UsuarioMaster}                                           from "../../services/auth";
import {CabecalhoTabela, FundoSistema, Obrigatorio, TelaSistema} from "../../assets/style";
import Menu                                                      from "../../components/menu";
import api                                                       from "../../services/api";
import debug                                                     from "../../utils/debug";

const Categoria = () => {
    const navegacao = useNavigate();
    const aviso = useRef(null);
    const endpointAPI = 'cadastro/categoria';
    const inicial = {id: 0, nome: '', descricao: '', icone: ''};
    const [loading, setLoading] = useState(true);
    const [item, setItem] = useState(inicial);
    const [lista, setLista] = useState([]);
    const [qtdeItens, setQtdeItens] = useState(0);
    const [pesquisaGeral, setPesquisaGeral] = useState(null);
    const [valorGlobalFiltro, setValorGlobalFiltro] = useState('');
    const [filtro, setFiltro] = useState({global: {value: null, matchMode: FilterMatchMode.CONTAINS}});

    useEffect(() => {
        if (!UsuarioMaster()) {
            navegacao('/sistema');
        } else {
            carregarItens();
        }
    }, []);

    const carregarItens = async () => {
        setLoading(true);
        await new api().requisitar('get', endpointAPI).then((resposta) => {
            setLista(resposta);
            setQtdeItens(resposta?.length ?? 0);
            setLoading(false);
        }).catch((erro) => {
            debug(erro);
        });
    };

    const limparTela = () => {
        setItem(inicial);
        carregarItens();
    };

    const excluir = async (id) => {
        await new api().requisitar('DELETE', `${endpointAPI}/${id}`).then((resposta) => {
            aviso.current.show({severity: 'success', summary: 'Confirmação', detail: resposta.mensagem, life: 3000});
            limparTela();
        }).catch((erro) => {
            debug(erro);
            aviso.current.show({
                                   severity: 'error',
                                   summary : 'Erro',
                                   detail  : (erro.response && erro.response.data && erro.response.data.error_description) ? erro.response.data.error_description : 'Ocorreu um erro não tratado',
                                   life    : 3000
                               });
        });
    };

    const aoMudarFiltroGlobal = (e) => {
        const value = e.target.value;
        let _filtro = {...filtro};
        _filtro['global'].value = value;

        setFiltro(_filtro);
        setValorGlobalFiltro(value);
    }
    const aoExcluirItem = (id) => {
        confirmDialog({
                          message    : `Confirma exclusão da categoria?`,
                          header     : 'Atenção',
                          icon       : 'pi pi-exclamation-triangle',
                          acceptLabel: 'Sim',
                          rejectLabel: 'Não',
                          accept     : () => {
                              excluir(id);
                          },
                      });
    };

    const aoSalvar = async () => {
        try {
            if (!item.nome) {
                throw {tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Informe o nome!'};
            }

            await new api().requisitar((item.id > 0) ? 'put' : 'post', (item.id > 0 ? `${endpointAPI}/${item.id ?? ''}` : endpointAPI), item).then((resposta) => {
                aviso.current.show({severity: 'success', summary: 'Confirmação', detail: resposta.mensagem, life: 3000});
                limparTela();
            }).catch((erro) => {
                throw {tipo: 'error', titulo: 'Falha!!', mensagem: erro.response.data ?? 'Ocorreu um erro não tratado'};
            });

        } catch (erro) {
            aviso.current.show({severity: erro.tipo ?? 'error', summary: erro.titulo ?? 'Erro', detail: erro.mensagem ?? erro, life: 3000});
        }
    };

    const aoDigitar = (e, propriedade) => {
        const texto = (e.target && e.target.value) || '';
        let _item = {...item};
        _item[`${propriedade}`] = texto;
        setItem(_item);
    };

    const cabecalhoTabela = (<React.Fragment>
        <CabecalhoTabela className='hidden md:flex'>
            <span className="m-0 text-lg">Categorias já cadastradas</span>
            <span className="p-input-icon-left">
                <i className="pi pi-search"/>
                <InputText value={valorGlobalFiltro} onChange={aoMudarFiltroGlobal} placeholder="Pesquise aqui"/>
            </span>
        </CabecalhoTabela>
        <div className='block md:hidden'>
            <div className='grid'>
                <div className="col-12">Categorias já cadastradas</div>
                <div className="col-12 p-input-icon-left">
                    <i className="pi pi-search"/>
                    <InputText value={valorGlobalFiltro} onChange={aoMudarFiltroGlobal} placeholder="Pesquise aqui"/>
                </div>
            </div>
        </div>
    </React.Fragment>);

    return (
        <FundoSistema>
            <Menu/>
            <Toast ref={aviso}></Toast>
            <TelaSistema title='Cadastro de Categorias'>
                <div className='grid'>
                    <div className="field col-12 md:col-6 lg:col-8">
                        <label htmlFor="nome">Nome<Obrigatorio>*</Obrigatorio> </label><br/>
                        <InputText className="w-full" autoComplete="none" id="nome" maxLength={255} value={item.nome} onChange={(e) => aoDigitar(e, 'nome')} required/>
                    </div>
                    <div className="field col-12 md:col-6 lg:col-4">
                        <span className="hidden md:block">
                            <label htmlFor="nome">&nbsp;</label><br/>
                        </span>
                        <Button label="Salvar" severity='success' icon="pi pi-check" className="p-button-text mr-2" raised onClick={aoSalvar}/>
                        {item.id > 0 && <React.Fragment>
                            <Button label="Excluir" severity='danger' icon="pi pi-trash" className="p-button-text mr-2" raised onClick={(e) => aoExcluirItem(item.id)}/>
                            <Button label="Cancelar" severity='help' icon="pi pi-undo" className="p-button-text" raised onClick={(e) => setItem(inicial)}/>
                        </React.Fragment>}
                    </div>
                    <div className="field col-12">
                        <DataTable removableSort stripedRows
                                   value={lista} responsiveLayout='stack' globalFilterFields={['nome']} selectionMode='single'
                                   selection={item} onSelectionChange={(e) => setItem(e.value)} loading={loading}
                                   globalFilter={pesquisaGeral} filters={filtro} header={cabecalhoTabela}
                                   emptyMessage='Nenhuma categoria cadastrada'>
                            <Column field={'nome'} header={'Nome da categoria'} sortable/>
                        </DataTable>
                    </div>
                </div>
            </TelaSistema>
        </FundoSistema>
    );
}

export default Categoria;